module.exports = __webpack_public_path__ + "static/media/location-arrow.ce62002e.svg";